'use strict';

require('../adsInsights/app.js');
require('../adsInsights/linkUtils.js');
require('./app.js');
require('./enums/alertFilters.js');
require('./enums/performanceSegmentTypes.js');
require('./utils.js');
require('./collections/alerts.js');
require('../../modules/data/alerts.js');
require('./views/alert.js');
require('./views/empty.js');
require('./views/alerts.js');
require('./views/empty.js');
require('./views/metricEvent.js');
require('./views/metricEventPosts.js');
require('./views/postEvent.js');
require('./views/textDiffEvent.js');
require('./views/urlDiffEvent.js');
require('./views/messageEvent.js');
require('./views/facebookAdsAlert.js');
require('./views/listeningAlert.js');
require('./views/alertFilter.js');
require('./widgets/alerts.js');
require('./curations/alerts.js');
